import React, { useState, useEffect } from 'react'
import '../css/App.css'
import axios from 'axios'
import Map from './Map'
import Controls from './Controls'
import Logo from './Logo'
import { LANGUAGES, URL, FEATURES_API, UI_LABELS_API, TAGS_API } from '../config'
let locations = []

function App() {
  const [map, setMap] = useState()
  const [lang, setLang] = useState(LANGUAGES[0])
  const [mapFeatures, setMapFeatures] = useState([])
  const [uiLabels, setUiLabels] = useState({})
  const [currentFeatureId, setCurrentFeatureId] = useState()
  const [currentFeature, setCurrentFeature] = useState()
  const [filters, setFilters] = useState([])
  const [searchKeyword, setSearchKeyword] = useState("")
  const [credits, setCredits] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios.get(URL + FEATURES_API)
      .then(({data}) => {
        locations = data
          .filter(p => p.positionGPS.length > 0 && p.description) // remove features without gps position or description
          .sort((a, b) => a.title.toUpperCase() > b.title.toUpperCase() ? 1 : -1) // sort by title

        setMapFeatures(locations)
      })

    axios.get(URL + TAGS_API)
      .then(({data}) => {
        setFilters(data.map(f => ({...f, selected: false})))
      })
    
    axios.get(URL + UI_LABELS_API)
      .then(({data}) => setUiLabels(data))
  }, [])

  useEffect(() => {
    if (currentFeatureId && currentFeatureId >= 0) {
      axios.get(URL + FEATURES_API + '/' + currentFeatureId)
        .then(({data}) => {
          setCurrentFeature({
            ...data,
            positionDescription: data.positionDescription && data.positionDescription[lang],
            description: data.description && data.description[lang],
            depth: data.depth && data.depth[lang],
            dating: data.Dating && data.Dating[lang],
            howToVisit: data.howToVisit && data.howToVisit[lang],
            bibliography: data.bibliography && data.bibliography[lang]
          })

          animateMapToLocation(map, [data.positionGPS[0].longitude, data.positionGPS[0].latitude])
        })
    } else {
      unsetFeature()
    }
  }, [currentFeatureId, lang])

  useEffect(() => {
    const activeFiltersIdByCategory = filters
      .filter(f => f.selected)
      .map(f => ({type: f.type, id: f.id}))
      .reduce((acc, {type, id}) => acc[type] ? {...acc, [type]: acc[type].concat([id])} : {...acc, [type]: [id]}, {})

    const filteredLocations = locations.filter(l => {
      const matched = Object.values(activeFiltersIdByCategory)
        .map(filterIds => filterIds.map(id => l.tags.some(tag => tag.id === id)))
        .reduce((acc, matchArrays) => acc.concat(matchArrays.some(v => v)), [])

      return matched.every(v => v)
    })

    setMapFeatures(filteredLocations)
  }, [filters])

  useEffect(() => {
    const activeFiltersIdByCategory = filters
      .filter(f => f.selected)
      .map(f => ({type: f.type, id: f.id}))
      .reduce((acc, {type, id}) => acc[type] ? {...acc, [type]: acc[type].concat([id])} : {...acc, [type]: [id]}, {})

    const filteredLocations = locations.filter(l => {
      const matched = Object.values(activeFiltersIdByCategory)
        .map(filterIds => filterIds.map(id => l.tags.some(tag => tag.id === id)))
        .reduce((acc, matchArrays) => acc.concat(matchArrays.some(v => v)), [])

      return matched.every(v => v)
    })

    const searchedLocations = filteredLocations.filter(l => {
      return l.title.toLowerCase().includes(searchKeyword.toLowerCase())
    })

    setMapFeatures(searchedLocations)
  }, [searchKeyword])

  useEffect(() => {
    if (map && map.loaded && mapFeatures && mapFeatures.length) {
      setLoading(false)
    }
  }, [map, mapFeatures])

  function getTranslatedUiLabel(key) {
    return (uiLabels && uiLabels[key] && uiLabels[key][lang]) || (uiLabels && "ERROR: MISSING KEY") || ""
  }

  function setFeature(id) {
    setCurrentFeatureId(id)
  }

  function unsetFeature() {
    setCurrentFeature(null)
    setCurrentFeatureId(null)
  }

  function toggleLanguage() {
    if (lang === LANGUAGES[0]) {
      setLang(LANGUAGES[1])
    }
    else {
      setLang(LANGUAGES[0])
    }
  }

  function animateMapToLocation(map, coordinates) {
    map.easeTo({
      center: coordinates,
      zoom: 14,
      speed: 3,
    })
  }

  return (
    <AppContext.Provider value={{
      map,
      setMap,
      animateMapToLocation,
      mapFeatures,
      setFeature,
      unsetFeature,
      currentFeature,
      filters,
      setFilters,
      lang,
      toggleLanguage,
      getTranslatedUiLabel,
      searchKeyword,
      setSearchKeyword,
      credits,
      setCredits,
      loading,
    }}>
      <div className="App">
        <Map />
        <Controls />
        <Logo />
      </div>
    </AppContext.Provider>
  )
}

export const AppContext = React.createContext({})
export default App